import { useEffect, useState } from "react"

import styled from "styled-components"

import B2B from "images/global/B2B.webp"
import blueCircles from "images/global/BlueCircles.svg"
import blueOvals from "images/global/BlueOvals.svg"
import bluePedals from "images/global/BluePedals.svg"
import blueSquares from "images/global/blueSquares.svg"
import blueStack from "images/global/BlueStack.svg"
import cards3 from "images/global/cardsPurple.svg"
import cards2 from "images/global/CardsSeafoam.svg"
import Crypto from "images/global/Crypto.webp"
import DiscsBaby from "images/global/DiscsBaby.svg"
import discs3 from "images/global/DiscsPurple.svg"
import discs2 from "images/global/DiscsSeaFoam.svg"
import Embedded from "images/global/Embedded.webp"
import glassCheck from "images/global/glassCheck.webp"
import GlassGraph from "images/global/glassGraphs.webp"
import Glass from "images/global/glassLightMode.webp"
import glassSearch from "images/global/glassSearch.webp"
import glassShield from "images/global/glassShield.webp"
import GlassWarning from "images/global/glassWarning.webp"
import Growth from "images/global/Growth.webp"
import Investing from "images/global/Investing.webp"
import APR from "images/global/kickerAPR.svg"
import Calendar from "images/global/kickerCalendar.svg"
import cards from "images/global/kickerCards.svg"
import circles from "images/global/kickerCircles.svg"
import circlesPurple from "images/global/kickerCirclesPurple.svg"
import CirclesBlue from 'images/global/CirclesBlue.webp';
import diskBlue from 'images/global/DiskBlue.webp';
import squaresAltBlue from 'images/global/squaresAltBlue.webp';
import SlicesDarkBlue from 'images/global/SlicesDarkBlue.webp';
import circles1 from 'images/global/Circles1.webp';
import discs from "images/global/kickerDiscs.svg"
import layers from "images/global/kickerLayers.svg"
import layers2 from "images/global/kickerLayers2.svg"
import cardsDarkBlue from 'images/global/cardsDarkBlue.svg';
import LayersBlue from 'images/global/LayersBlue.webp';
import SquaresBlue from 'images/global/SquaresBlue.webp';
import SlicesBlue from 'images/global/SlicesBlue.webp';
import Portfolio from "images/global/kickerPortfolio.svg"
import slices from "images/global/kickerSlices.svg"
import SlicesBaby from "images/global/SlicesBaby.svg"
import squares from "images/global/kickerSquares.svg"
import layersAlt from "images/global/layersAlt.svg"
import LayersAltSeafoam from "images/global/layersAltSeafoam.svg"
import circlesLightBlue from 'images/global/circlesLightBlue.svg';
import layersBaby from "images/global/layersBaby.svg"
import Neobanking from "images/global/Neobanking.webp"
import slices2 from "images/global/slices2.svg"
import SlicesAlt from "images/global/slicesAlt.webp"
import squares2 from "images/global/squares2.svg"
import SquaresAlt from "images/global/squaresAlt.webp"
import colors from "styles/colors"
import media from "styles/media"
import text, { transparentText } from "styles/text"
import { ColorType } from "types"

const imageMap = {
  cards,
  cards2,
  cards3,
  layers,
  layers2,
  layersBaby,
  discs,
  discs2,
  discs3,
  slices,
  squares,
  squares2,
  circles,
  DiscsBaby,
  squaresAltBlue,
  circlesLightBlue,
  CirclesBlue,
  diskBlue,
  SlicesDarkBlue,
  circlesPurple,
  circles1,
  LayersBlue,
  SquaresBlue,
  cardsDarkBlue,
  SlicesBlue,
  growth: Growth,
  crypto: Crypto,
  investing: Investing,
  b2b: B2B,
  embedded: Embedded,
  neobanking: Neobanking,
  apr: APR,
  calendar: Calendar,
  portfolio: Portfolio,
  glass: Glass,
  glassGraph: GlassGraph,
  glassWarning: GlassWarning,
  glassCheck,
  glassSearch,
  glassShield,
  slicesAlt: SlicesAlt,
  squaresAlt: SquaresAlt,
  blueStack,
  blueSquares,
  blueCircles,
  blueOvals,
  bluePedals,
  layersAltSeafoam: LayersAltSeafoam,
  layersAlt,
  slices2,
  SlicesBaby,
  none: "",
}

export type KickerTextType = keyof typeof imageMap

interface Props {
  kickerText?: string | undefined
  kickerIcon?: KickerTextType
  largeIcon?: boolean
  centered?: boolean | undefined
  small?: boolean
  gradient?: string
  color?: ColorType
}

export default function Kicker({
  kickerText = undefined,
  kickerIcon = undefined,
  centered = false,
  small = false,
  largeIcon = false,
  gradient = undefined,
  color = undefined,
}: Props) {
  const [kickerImage, setKickerImage] = useState<string>("")

  useEffect(() => {
    if (kickerIcon) {
      setKickerImage(imageMap[kickerIcon])
    }
  }, [kickerIcon])

  return (
    <KickerWrapper centered={centered}>
      {kickerIcon && (
        <KickerImage largeIcon={largeIcon} src={kickerImage} alt="small icon" />
      )}
      {kickerText && (
        <Text gradient={gradient} small={small} color={color}>
          {kickerText}
        </Text>
      )}
    </KickerWrapper>
  )
}

const KickerWrapper = styled.div<{
  centered: boolean | undefined
}>`
  display: flex;
  margin-bottom: 1.205vw;
  align-items: center;
  justify-content: ${props => (props.centered ? "center" : "flex-start")};
  text-align: ${props => (props.centered ? "center" : "left")};
  width: 100%;

  ${media.fullWidth} {
    margin-bottom: 20px;
  }
  ${media.tablet} {
    margin-bottom: ${({ centered }) => (centered ? "0.977vw" : "1.953vw")};
  }
  ${media.mobile} {
    margin-bottom: 2.667vw;
  }
`

const KickerImage = styled.img<{ largeIcon: boolean }>`
  ${media.fullWidth} {
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }

  ${media.desktop} {
    width: 1.506vw;
    height: 1.506vw;
    margin-right: 0.602vw;
  }
  ${media.tablet} {
    width: ${({ largeIcon }) => (largeIcon ? "3.418vw" : "2.441vw")};
    height: ${({ largeIcon }) => (largeIcon ? "3.418vw" : "2.441vw")};
    margin-right: 0.977vw;
  }
  ${media.mobile} {
    width: ${({ largeIcon }) => (largeIcon ? "9.333vw" : "6.667vw")};
    height: ${({ largeIcon }) => (largeIcon ? "9.333vw" : "6.667vw")};
    margin-right: 2.667vw;
  }
`

const Text = styled.div<{
  color: string | undefined
  small: boolean | undefined
  gradient: string | undefined
}>`
  color: ${props => (props.color ? props.color : colors.blue50)};
  ${props => (props.small ? text.buttonL : text.captionKicker)};
  background: ${props => (props.gradient ? props.gradient : "unset")};
  ${props => props.gradient && transparentText}
`
